module.exports = __webpack_public_path__ + "static/media/featuredesign.821ef405.jpeg";